var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 23,
    height: 23.5,
    viewBox: "0 0 23 23.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.75 4.75002H11.75C12.35 4.75002 12.75 5.15002 12.75 5.75002V7.75002M4.75 18.75H11.75C12.35 18.75 12.75 18.35 12.75 17.75V15.75M21.75 11.75H9.75M18.75 7.75002L21.95 10.95C22.35 11.35 22.35 11.95 21.95 12.35L18.75 15.75M0.75 4.55002L4.75 0.750018V22.75L0.75 18.95V4.55002Z",
    stroke: "#4A5565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutDark);
export default __webpack_public_path__ + "static/media/logout-dark.fa2eb91aa3e18da7d3c40a589293d3f4.svg";
export { ForwardRef as ReactComponent };